import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import GameIcon from "../../images/Game";
import SDKIcon from "../../images/SDKIcon";
import UserIcon from "../../images/UserIcon";
import Collapse from '@mui/material/Collapse';
import Coupon from "../../images/Coupon";
import SettingIcon from "../../images/settingIcon";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AnalyticsIcon from "../../images/AnalyticsIcon";
import GenzizBanner from "../../assets/images/GenzizBanner.png";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemButton from '@mui/material/ListItemButton';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import RevenueIcon from "../../images/RevenueIcon";
import { agentDetails, hideActionFunc, userDetails } from "../../utils";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useDispatch, useSelector } from "react-redux";
import { getFlagConfig, getPaymentGateway } from "../../Redux/settings/action";
import { getPermissionsKey } from "../../Redux/AdminUser/action";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';


function LeftContent() {
    const dispatch = useDispatch()
    const settingFlag = useSelector(state => state?.settingReducer?.flagList)
    const navigate = useNavigate();
    const [, updateState] = React.useState({});
    const [paymentList, setpaymentList] = useState()
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [menusList, setMenuList] = useState([

        // Admin Users menu
        {
            icon: <UserIcon />,
            label: "Admin Users",
            src: "admin-users",
            value: 'admin',
            hasMoreMenu: false,
        },
        // Users menu with expandable submenus
        {
            icon: <UserIcon />,
            label: "Users",
            src: "Users",
            // id: 'userId',
            value: 'user',
            // isExpanded: false,
            hasMoreMenu: false,
            expandArray: [
                //     // {
                //     //     icon: '',
                //     //     label: "All Users",
                //     //     src: "Users",
                //     // },
                //     // {
                //     //     icon: '',
                //     //     label: "Inactive Users",
                //     //     src: "inactive-users",
                //     // },
                // {
                //     icon : '',
                //     label: settingFlag?.isMobileNumberUpdateRequest ?  'Users Mobile Number Request' : "Users Mobile Number Request",
                //     src:'user/update-mobile-number'

                // },
            ]
        },
        // Games menu with expandable submenus
        {
            icon: <GameIcon />,
            label: "Games",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'gameId',
            value: 'game',
            expandArray: [
                {
                    icon: '',
                    label: "All Games",
                    src: "games/all-games",
                },
                {
                    icon: '',
                    label: "Approved Games",
                    src: "games/approved-games",
                },
                hideActionFunc('game') &&
                {
                    icon: '',
                    label: "Add New Game",
                    src: "games/add-game",
                },
                {
                    icon: '',
                    label: "Games Tracking",
                    src: "games/games-tracking",
                },
            ]
        },
        // Analytics menu with expandable submenus
        {
            icon: <AnalyticsIcon />,
            label: "Analytics   ",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'analytics',
            value: 'analytics',
            expandArray: [
                {
                    icon: '',
                    label: "Analytics Report",
                    src: "analytics-report",
                },
                {
                    icon: '',
                    label: "Analytics Overview Report",
                    src: "analytics-overview-report",
                },
                {
                    icon: '',
                    label: "Application Install & Uninstall",
                    src: "analytics-application-install",
                },
                {
                    icon: '',
                    label: "Retention Report",
                    src: "analytics-retention-report",
                },
                {
                    icon: '',
                    label: "Game Analytics",
                    src: "analytics-game-report",
                },
            ]
        },
        // Popular Games menu
        {
            icon: <GameIcon />,
            label: "Popular Games",
            src: "popular-games",
            value: 'popularGame',
            hasMoreMenu: false,
        },
        // Bonus menu with expandable submenus
        {
            icon: <Coupon />,
            label: "Bonus",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'bonusId',
            value: 'bonus',
            expandArray: [
                {
                    icon: '',
                    label: "Leaderboard",
                    src: "leaderboard",
                },
                {
                    icon: '',
                    label: "Daily Bonus",
                    src: "daily-wheel-bonus",
                },
                {
                    icon: '',
                    label: "Daily Login Reward",
                    src: "daily-reward",
                },
                {
                    icon: '',
                    label: "Refer & Earn",
                    src: "refer-and-earn",
                },
            ]
        },
        // Revenue menu with expandable submenus
        {
            icon: <RevenueIcon />,
            label: "Revenue",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'revenue',
            value: 'revenue',
            expandArray: [
                {
                    icon: '',
                    label: "Payment History",
                    src: "revenue/payment-history",
                },
                {
                    icon: '',
                    label: "Ads Watch Data",
                    src: "revenue/ads-watch-data",
                },
            ]
        },
        // Master menu with expandable submenus
        {
            icon: <LeaderboardIcon />,
            label: "Master",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'master',
            value: 'master',
            expandArray: [
                {
                    icon: '',
                    label: "Avatars",
                    src: "avatars",
                },
                {
                    icon: '',
                    label: "Quick Chat",
                    src: "quick-chat",
                },
                {
                    icon: '',
                    label: "Store Packs",
                    src: "store-pack",
                },
                {
                    icon: '',
                    label: 'Bot',
                    src: 'bot'
                },
                {
                    icon: '',
                    label: "Game Category",
                    src: 'games/category'
                },
                // {
                //     icon: '',
                //     label: "Promotion Ads List",
                //     src: "ads-list",
                // },
                {
                    icon: '',
                    label: 'Documentation',
                    src: 'documentation'
                },
                {
                    icon: '',
                    label: 'Lobby Type',
                    src: 'lobby-label'
                },
                // {
                //     icon: '',
                //     label: 'Gamziz Online Players',
                //     src: 'online-players'
                // },
                // {
                //     icon: '',
                //     label: 'Game Mode Design',
                //     src: 'gameModeDesign'
                // },
                {
                    icon: '',
                    label: 'App Languages',
                    src: 'app-languages'
                },
                {
                    icon: '',
                    label: 'Private Rooms',
                    src: 'private-rooms'
                },
                {
                    icon: '',
                    label: 'Hubble Coupon Out Of India Manage',
                    src: 'hubble-coupon-out-of-india'
                },
                {
                    icon: '',
                    label: 'Manage Country',
                    src: 'manage-country'
                },
                // {
                //     icon: '',
                //     label: 'Report Reason',
                //     src: 'report-reason'
                // },
                // {
                //     icon: '',
                //     label: "Notification",
                //     src: "notification",
                // },

                {
                    icon: '',
                    label: settingFlag?.isMobileNumberUpdateRequest ? 'Users Mobile Number Request' : "Users Mobile Number Request",
                    src: 'user/update-mobile-number'
                },
            ]
        },
        // Marketing menu with expandable submenus
        {
            icon: <TrendingUpIcon />,
            label: "Marketing",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'marketing',
            value: 'marketing',
            expandArray: [
                {
                    icon: '',
                    label: "Promotion Banners",
                    src: "ads-list",
                },
                {
                    icon: '',
                    label: "Notification",
                    src: "notification",
                },
                // {
                //     icon: '',
                //     label:"Offer",
                //     src: "offer",
                // },
            ]
        },
        // Design menu with expandable submenus
        {
            icon: <SettingIcon />,
            label: "Design",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'design',
            value: 'design',
            expandArray: [
                {
                    icon: '',
                    label: "Splash Screen",
                    src: "splash-screen",
                },
                // {
                //     icon: '',
                //     label: "Login Screen",
                //     src: "LoginScreen",
                // },
                {
                    icon: '',
                    label: "Home Screen",
                    src: "HomeScreen",
                },
                // {
                //     icon: '',
                //     label: "Refer & Earn Design",
                //     src: "referAndEarn",
                // },
            ]
        },
        // Settings menu with expandable submenus
        {
            icon: <SettingIcon />,
            label: "Settings",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'settings',
            value: 'setting',
            expandArray: [
                {
                    icon: '',
                    label: "Flag Config",
                    src: "setting/flag-config",
                },
                {
                    icon: '',
                    label: "Global Config",
                    src: "setting/config",
                },
                {
                    icon: '',
                    label: "Maintenance",
                    src: "setting/maintenance",
                },
                {
                    icon: '',
                    label: "Restrict Geo",
                    src: "setting/restrict-geo",
                },
                {
                    icon: '',
                    label: "Ads Config",
                    src: "setting/ads-config",
                },


            ]
        },
        // Gamziz Release menu 
        {
            icon: <SDKIcon />,
            label: "Gamziz Release",
            src: "release",
            value: 'mgpRelease',
            hasMoreMenu: false,
        },
        // Help & Support menu 
        {
            icon: <HelpCenterIcon />,
            label: "Help & Support",
            hasMoreMenu: true,
            isExpanded: false,
            id: 'helpAndSupport',
            value: 'helpAndSupport',
            expandArray: [
                {
                    icon: '',
                    label: "Help & Support Tickets",
                    src: "help-and-support",
                },
                {
                    icon: '',
                    label: "App Feedback",
                    src: "app-feedback",
                },
            ]
        },
    ]);


    const { role: userRole } = userDetails();

    useEffect(() => {
        dispatch(getFlagConfig({}))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    //    useEffect(() => {

    //        if (paymentList?.depositPaymentGateway === "Manually") {
    //            let newmenu = menusList
    //            menusList[13]?.expandArray?.push({
    //                 icon: '',
    //                 label: "User Deposit Manually",
    //                 src: "user-deposit-request",
    //            },
    //             {
    //                 icon: '',
    //                 label: "Add UPI QR Code",
    //                 src: "upi-qr-code",
    //             },)
    //            setMenuList(newmenu)
    //        }
    //     if (paymentList?.withdrawalPaymentGateway === "Manually") {
    //         let newmenu = menusList
    //         menusList[12]?.expandArray?.push({
    //             icon: '',
    //             label: "Withdrawal Manually",
    //             src: "withdrawal-manually",
    //         },)
    //         setMenuList(newmenu)
    //     }
    //    }, [paymentList , menusList])

    useEffect(() => {
        setMenuList(prevMenus => {
            let newMenus = [...prevMenus];
            const withdrawalMenu = newMenus.find(menu => menu.id === "withdrawal");

            if (withdrawalMenu) {
                let changed = false;
                if (paymentList?.depositPaymentGateway === "Manually") {
                    const existsDeposit = withdrawalMenu.expandArray.find(
                        item => item.src === "user-deposit-request"
                    )
                    if (!existsDeposit) {
                        withdrawalMenu.expandArray.push(
                            {
                                icon: '',
                                label: "User Deposit Manually",
                                src: "user-deposit-request",
                            },
                            {
                                icon: '',
                                label: "Add UPI QR Code",
                                src: "upi-qr-code",
                            }
                        );
                        changed = true;
                    }
                }

                if (paymentList?.withdrawalPaymentGateway === "Manually") {
                    const existsWithdraw = withdrawalMenu.expandArray.find(
                        item => item.src === "withdrawal-manually"
                    )
                    if (!existsWithdraw) {
                        withdrawalMenu.expandArray.push({
                            icon: '',
                            label: "Withdrawal Manually",
                            src: "withdrawal-manually",
                        });
                        changed = true;
                    }
                }
                return changed ? newMenus : prevMenus;
            }
            return prevMenus;
        });
    }, [paymentList]);

    // useEffect(()=>{
    //     if(JSON.parse(localStorage.getItem('userdata'))?.role === 'AdminUser'){
    //         let temp = [...menusList]
    //         setMenuList([ {
    //             icon: <UserIcon />,
    //             label: "Sub Admin Users",
    //             src: "sub-adminUser",
    //             value: 'subAdminUser',
    //             hasMoreMenu: false,
    //         }, ...temp])
    //     }
    // },[])

    const handleClicked = (e) => {
        navigate(`/${e}`)
    };

    const ToggleMenu = (Id) => {
        menusList.filter(item => item.id === Id)[0].isExpanded = !menusList.filter(item => item.id === Id)[0].isExpanded;
        forceUpdate();
    };

    const handleSidebar = (menu) => {
        const isLeaderboardOn = settingFlag?.isGameLeaderboardBonus || settingFlag?.isGlobalLeaderboardOn || settingFlag?.isXpLeaderboardOn;

        if (!isLeaderboardOn && !settingFlag?.isMobileNumberUpdateRequest) {
            return menu?.expandArray?.filter(item => (!item?.label?.includes('Users Mobile Number Request') && item?.label !== 'Leaderboard'))?.map((list, i) => {
                return list && <Collapse in={menu?.isExpanded} timeout="auto" unmountOnExit key={i} className={((window.location.pathname.includes('/users-tab') && list?.label === 'All Users') || (window.location.pathname.includes('/game-tab') && list?.label === 'All Games')) ? 'inner_list_details activeClass' : 'inner_list_details'}>
                    <List component="div" disablePadding onClick={() => handleClicked(list?.src)} >
                        <ListItemButton className='list_item' selected={list?.src === window.location.pathname.replace('/', '')} >
                            {
                                list?.icon && <ListItemIcon>
                                    {list?.icon}
                                </ListItemIcon>
                            }
                            <ListItemText primary={list?.label} className="menu_label fontFamily" />
                        </ListItemButton>
                    </List>
                </Collapse>
            })
        }
        if (!isLeaderboardOn) {
            return menu?.expandArray?.filter(item => item?.label !== "Leaderboard")?.map((list, i) => {
                return list && <Collapse in={menu?.isExpanded} timeout="auto" unmountOnExit key={i} className={((window.location.pathname.includes('/users-tab') && list?.label === 'All Users') || (window.location.pathname.includes('/game-tab') && list?.label === 'All Games')) ? 'inner_list_details activeClass' : 'inner_list_details'}>
                    <List component="div" disablePadding onClick={() => handleClicked(list?.src)} >
                        <ListItemButton className='list_item' selected={list?.src === window.location.pathname.replace('/', '')} >
                            {
                                list?.icon && <ListItemIcon>
                                    {list?.icon}
                                </ListItemIcon>
                            }
                            <ListItemText primary={list?.label} className="menu_label fontFamily" />
                        </ListItemButton>
                    </List>
                </Collapse>
            })
        }
        if (!settingFlag?.isMobileNumberUpdateRequest) {
            return menu?.expandArray?.filter(item => item?.label !== 'Users Mobile Number Request')?.map((list, i) => {
                return list && <Collapse in={menu?.isExpanded} timeout="auto" unmountOnExit key={i} className={((window.location.pathname.includes('/users-tab') && list?.label === 'All Users') || (window.location.pathname.includes('/game-tab') && list?.label === 'All Games')) ? 'inner_list_details activeClass' : 'inner_list_details'}>
                    <List component="div" disablePadding onClick={() => handleClicked(list?.src)} >
                        <ListItemButton className='list_item' selected={list?.src === window.location.pathname.replace('/', '')} >
                            {
                                list?.icon && <ListItemIcon>
                                    {list?.icon}
                                </ListItemIcon>
                            }
                            <ListItemText primary={list?.label} className="menu_label fontFamily" />
                        </ListItemButton>
                    </List>
                </Collapse>
            })
        }


        if (isLeaderboardOn && settingFlag?.isMobileNumberUpdateRequest) {
            return menu?.expandArray?.map((list, i) => {
                return list && <Collapse in={menu?.isExpanded} timeout="auto" unmountOnExit key={i} className={((window.location.pathname.includes('/users-tab') && list?.label === 'All Users') || (window.location.pathname.includes('/game-tab') && list?.label === 'All Games')) ? 'inner_list_details activeClass' : 'inner_list_details'}>
                    <List component="div" disablePadding onClick={() => handleClicked(list?.src)} >
                        <ListItemButton className='list_item' selected={list?.src === window.location.pathname.replace('/', '')} >
                            {
                                list?.icon && <ListItemIcon>
                                    {list?.icon}
                                </ListItemIcon>
                            }
                            <ListItemText primary={list?.label} className="menu_label fontFamily" />
                        </ListItemButton>
                    </List>
                </Collapse>
            })
        }
    }
    useEffect(() => {
        dispatch(getPermissionsKey())
        dispatch(getPaymentGateway({})).then(res => {
            if (res.data.success) {
                setpaymentList(prev => ({
                    ...prev,
                    ...res.data.data
                }));
            }
        })
    }, [dispatch])


    return (
        <div className='gp_left-bar' style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <div className='side_logo_box' style={{ flexShrink: 0 }}>

                <Link className='side_logo' to="/dashboard" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px 20px', gap: '14px', height: '125px' }}>
                    {/* <img src={G7Logo} alt={"G7 Logo"} style={{ width: '80px', height: '80px', minWidth: '80px', objectFit: 'contain', margin: 0 }} /> */}
                    <img src={GenzizBanner} alt={"GENZIZ"} style={{ height: '100px', width: 'auto', maxWidth: '220px', objectFit: 'contain', margin: 0 }} />
                </Link>
            </div>
            <List sx={{ width: '100%', maxWidth: 360, padding: '0 0 20px 0', flex: 1, overflowY: 'auto', overflowX: 'hidden' }} component="nav" aria-labelledby="nested-list-subheader" className={"tab_sidebar_details"}>
                {
                    menusList?.map((menu, i) => {
                        //let agentDataDetails = JSON.parse(localStorage.getItem('agentData')) ||
                        //let agentDataDetails = cookies.get('agentData');
                        let agentDataDetails = agentDetails();
                        let payload = {
                            permission: {
                                ...agentDataDetails.permission,
                                subAdminUser: {
                                    editor: JSON.parse(localStorage.getItem('userdata'))?.role === 'AdminUser',
                                    viewer: JSON.parse(localStorage.getItem('userdata'))?.role === 'AdminUser'
                                }
                            }
                        }
                        let AgentCondition = agentDataDetails !== 'null' && (payload && menu.value === (Object?.keys(payload?.permission || {})[Object?.keys(payload?.permission || {})?.indexOf(menu.value)]));
                        let agentValueViewer = (Object?.keys(payload?.permission || {})?.length > 0 && payload?.permission[(Object?.keys(payload?.permission || {})[Object?.keys(payload?.permission || {})?.indexOf(menu.value)])]?.viewer);
                        let agentValueEditor = (Object?.keys(payload?.permission || {})?.length > 0 && payload?.permission[(Object?.keys(payload?.permission || {})[Object?.keys(payload?.permission || {})?.indexOf(menu.value)])]?.editor);
                        let agentValue = (agentValueViewer || agentValueEditor)
                        return (
                            <React.Fragment key={i}>
                                {/* Check if user has permission to view the menu */}

                                {(((userRole) === 'Admin') || (AgentCondition && agentValue)) && (
                                    <>
                                        <ListItemButton sx={{ padding: "5px 15px" }} selected={menu?.src === window.location.pathname.replace('/', '')} className='list_item fontFamily' onClick={() => menu.hasMoreMenu ? ToggleMenu(menu?.id) : handleClicked(menu?.src)}>
                                            <ListItemIcon style={{ minWidth: "20px" }} className={'icon-left-side fontFamily'}>
                                                {menu?.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={menu?.label} className="menu_label fontFamily" />
                                            {menu?.hasMoreMenu ? menu?.isExpanded ? <ExpandMore /> : <ExpandLess /> : ''}
                                        </ListItemButton>

                                        {menu?.expandArray &&
                                            handleSidebar(menu)
                                        }
                                    </>
                                )}
                            </React.Fragment>
                        )
                    })
                }
            </List>
        </div>
    )
}

export default LeftContent